import React, { useEffect, useRef } from "react";

export default function ScrollToMe() {

    const target = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (target.current?.offsetTop) {
            console.log('scrollTo', target.current?.offsetTop)
            window.scrollTo({
                top: target.current?.offsetTop,
                behavior: 'smooth'
            });
        }
    }, [target])

    return (<div ref={target}></div>)
}
